export const descriptionHebergement = {
  CP: "campings",
  AC: "activités",
  A: "hébergements",
  PC: "hébergements"
};

export const RESERVATION_TEMP_TIMEOUT = 15*60*1000; //timeout dans la bd: 5*60*1000ms